// extracted by mini-css-extract-plugin
module.exports = {"root":"NFTs_root__gM3s4","item":"NFTs_item__lWRR4","image":"NFTs_image__b0S7q","title":"NFTs_title__4DS9K"};